export enum MaskPlaceholder {
  DATE = 'DD.MM.YYYY',
}
